import { createContext, type PropsWithChildren } from "react";
import usePaymentMethods from "./usePaymentMethods";

export const PaymentMethodsContext = createContext({} as ReturnType<typeof usePaymentMethods>);

const PaymentMethodsProvider = ({ children }: PropsWithChildren) => (
    <PaymentMethodsContext.Provider
        value={usePaymentMethods()}
    >
        {children}
    </PaymentMethodsContext.Provider>
);

export default PaymentMethodsProvider;
